export interface VideoCollection {
  id: string;
  title: string;
  subtitle: string;
  accent: "primary" | "accent" | "secondary";
  videoIds: string[];
}

export const collections: VideoCollection[] = [
  {
    id: "weekly-hot",
    title: "本周热播",
    subtitle: "全站播放量飙升的当季热门，错过就亏大了",
    accent: "primary",
    videoIds: ["t05", "m01", "a03", "t02", "m04", "a01"],
  },
  {
    id: "high-score-movie",
    title: "高分电影推荐",
    subtitle: "口碑与画质双在线，值得反复回味的佳作",
    accent: "accent",
    videoIds: ["m01", "m03", "m02", "m06", "m05", "m04"],
  },
  {
    id: "suspense-picks",
    title: "悬疑剧精选",
    subtitle: "烧脑反转停不下来，一口气追到天亮",
    accent: "secondary",
    videoIds: ["t05", "m06", "m02", "t04", "t01", "t03"],
  },
];